import FindApplication from './components/FindApplication';
import Empty from '../../components/base/Empty';
import CarrierRegistryPage from './components/CarrierRegistryPage';
import VehicleRegistryPage from './components/VehicleRegistryPage';
import SZLTRegistryPage from './components/SZLTRegistryPage';

const routes = [
  {
    path: '/region-registry-carrier',
    name: 'menu.region.registry',
    icon: 'region-registry',
    customIcon: true,
    loginRequired: true,
    component: () => null,
    weight: 2,
    permission: [],
    children: [
      {
        path: '/region-registry/find',
        name: 'menu.application',
        icon: 'application',
        customIcon: true,
        loginRequired: true,
        onlyComponent: true,
        component: Empty,
        MenuComponent: FindApplication,
        weight: 2,
        permission: [],
        children: [],
      },
      {
        path: '/region-registry-carrier',
        name: 'menu.region.registry.carrier',
        icon: 'application',
        customIcon: true,
        loginRequired: true,
        component: CarrierRegistryPage,
        weight: 2,
        permission: [],
        children: [],
      },
      {
        path: '/region-registry/passenger-taxi',
        name: 'menu.region.registry.passenger.taxi',
        icon: 'application',
        customIcon: true,
        loginRequired: true,
        component: VehicleRegistryPage,
        weight: 2,
        permission: [],
        children: [],
      },
      {
        path: '/region-registry/szlt',
        name: 'menu.region.registry.szlt',
        icon: 'application',
        customIcon: true,
        loginRequired: true,
        component: SZLTRegistryPage,
        weight: 2,
        permission: [],
        children: [],
      },
    ],
  },
];

export default routes;
